import React from "react";

import { ChevronDownIcon, ChevronUpIcon } from "components/SvgIcons";
import { colours } from "@shared/ui.design-system";
import { chevronWrapper } from "../ATBConfirmation/ATBConfirmation.css";

type ExpanderButtonProps = {
  showMore: boolean;
  toggleShowMore: () => void;
};

export const ExpanderButton: React.FC<ExpanderButtonProps> = ({
  showMore,
  toggleShowMore
}): JSX.Element => {
  return (
    <button
      type="button"
      data-testid="expander-button"
      className={chevronWrapper}
      style={{ position: showMore ? "absolute" : "relative" }}
      onClick={toggleShowMore}
    >
      {showMore ? (
        <ChevronDownIcon
          data-testid="chevron-down-icon"
          width="1.25rem"
          height="1.25rem"
          stroke={colours.primary.dark}
          strokeWidth="1"
        />
      ) : (
        <ChevronUpIcon
          data-testid="chevron-up-icon"
          width="1.25rem"
          height="1.25rem"
          stroke={colours.primary.dark}
          strokeWidth="1"
        />
      )}
    </button>
  );
};
